'use strict';

var React = require('react'),
    getThumURL = require('thum.io').getThumURL;

var DocsExample = React.createClass({
	displayName: 'DocsExample',

	getInitialState: function getInitialState() {
		return {
			url: getThumURL({
				protocol: 'https',
				width: 100,
				crop: 600,
				url: 'https://www.google.com'
			})
		};
	},

	render: function render() {
		return React.createElement(
			'div',
			null,
			React.createElement(
				'div',
				{ className: 'form-group' },
				React.createElement('input', {
					type: 'text',
					className: 'form-control',
					value: this.state.url,
					onChange: this.updateUrl
				})
			),
			React.createElement(
				'a',
				{ href: this.state.url, target: '_blank', className: 'btn btn-primary' },
				'Preview generated thumbnail'
			)
		);
	},

	updateUrl: function updateUrl(e) {
		this.setState({ url: e.target.value });
	}
});

module.exports = DocsExample;


//////////////////
// WEBPACK FOOTER
// ./client/components/DocsExample.js
// module id = 421
// module chunks = 0